module.exports = __webpack_public_path__ + "img/text-width.49bbec7c.svg";